import { useEffect, useRef } from "react";
import type { useScheduleExportAnalytics } from "./useScheduleExportAnalytics";

/**
 * Report a preview's build as it starts and as it finishes.
 *
 * Derived from the loading flag rather than threaded through each preview hook as callbacks: the two
 * tabs load in completely different ways (a local render vs a cached request) but both expose the same
 * "am I loading" answer, and the pair of events is what gives us preview latency per tab.
 */
export const useTrackPreviewLifecycle = (isLoading: boolean, hasError: boolean, analytics: ReturnType<typeof useScheduleExportAnalytics>): void => {
	const wasLoading = useRef(false);

	useEffect(() => {
		if (isLoading && !wasLoading.current) analytics.trackPreviewStart();
		// A cycle that ended in failure is already reported by the error path; don't call it a success.
		else if (!isLoading && wasLoading.current && !hasError) analytics.trackPreviewSuccess();
		wasLoading.current = isLoading;
	}, [isLoading, hasError, analytics]);
};
